var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"star","d":"M37.973,57.982a.928.928,0,0,1-.545-.174L29.965,52.4,22.5,57.808a.928.928,0,0,1-1.425-1.049l2.911-8.621-7.543-5.173a.928.928,0,0,1,.522-1.694h9.306l2.809-8.643a.928.928,0,0,1,1.766,0l2.809,8.646h9.306a.928.928,0,0,1,.525,1.694l-7.546,5.17,2.909,8.619a.928.928,0,0,1-.878,1.226Z","transform":"translate(-16.041 -31.985)","fill":"#926ff9"}));
}

Star.defaultProps = {"width":"27.851","height":"26","viewBox":"0 0 27.851 26"};

module.exports = Star;

Star.default = Star;
